/**
 * @generated SignedSource<<a0dd8e9e2751afb93bc8773012e592c9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductDrawerFragment$data = {
  readonly id: string;
  readonly priceAmount: number;
  readonly product: {
    readonly brand: {
      readonly id: string;
      readonly name: string;
      readonly organization: {
        readonly id: string;
        readonly imprint: string | null | undefined;
        readonly name: string;
      };
    };
    readonly category: {
      readonly i18N: any;
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly description: string | null | undefined;
    readonly id: string;
    readonly name: string;
    readonly photo: {
      readonly id: string;
      readonly variant: string;
    };
  };
  readonly stock: number;
  readonly " $fragmentType": "ProductDrawerFragment";
};
export type ProductDrawerFragment$key = {
  readonly " $data"?: ProductDrawerFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDrawerFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductDrawerFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stock",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CloudflareImage",
          "kind": "LinkedField",
          "name": "photo",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "variant",
                  "value": "PUBLIC"
                }
              ],
              "kind": "ScalarField",
              "name": "variant",
              "storageKey": "variant(variant:\"PUBLIC\")"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Brand",
          "kind": "LinkedField",
          "name": "brand",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            (v1/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Organization",
              "kind": "LinkedField",
              "name": "organization",
              "plural": false,
              "selections": [
                (v0/*:: as any*/),
                (v1/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "imprint",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Category",
          "kind": "LinkedField",
          "name": "category",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            (v1/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "i18N",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HubProduct",
  "abstractKey": null
};
})();

(node as any).hash = "336d6aa18951472d180d9e211807381b";

export default node;
